import styled from 'styled-components'

import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../../../../fundamentals/text-styles/constants.js'
import colorsOptions from '../../../../fundamentals/colors-styles/constants.js'

export const ToolbarContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`

export const ToolbarShell = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const BarContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.5rem;
`

export const FilterTitle = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-90']};
`

export const OptionsContainer = styled.div`
  width: auto;
  display: flex;
  align-items: center;
`

export const FilterOption = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-90']};

  &[data-selected='true'] {
    ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
    color: ${colorsOptions.docuToolsOrange.orange};
  }
`

export const ItemsPageContainer = styled.div`
  display: flex;
  align-items: center;
  width: auto;
  gap: 1rem;
  flex-shrink: 0;
`

export const ItemsPageLabel = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-70']};
  flex-shrink: 0;
  margin-right: 0.5rem;
`

export const DropdownContainer = styled.div`
  width: 48px;
`

export const EditButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
`

export const LeftContainer = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: flex-start;
`

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
`
